<app-chart [title]="title" [tooltip]="tooltip">
    <div class="content">
        <div class="content-titles">
            <div class="categories-title">
                {{ "visibilityDashboardPage.topBuildersCreatorTitle" | labelsProvider }}
            </div>
            <div class="sub-categories">
                <div class="sub-categories-title">
                    {{ "visibilityDashboardPage.topBuildersApplicationTitle" | labelsProvider }}
                </div>
                <div class="sub-categories-title">
                    {{ "visibilityDashboardPage.topBuildersAutomationTitle" | labelsProvider }}
                </div>
                <div class="sub-categories-title">
                    {{ "visibilityDashboardPage.topBuildersAgentTitle" | labelsProvider }}
                </div>
                <div class="sub-categories-title">
                    {{ "visibilityDashboardPage.topBuildersDataStorageTitle" | labelsProvider }}
                </div>
            </div>
        </div>
        <div class="content-items">
            <div *ngFor="let item of seriesData" class="content-item">
                <div class="category-name" (click)="goToInventoryPageByCreatorId(item.categoryLinkValue, 'application,automation,bot,dataStorage')">
                    {{ item.categoryName }}
                </div>
                <div class="amountPerSubCategory">
                    <div class="item Application" (click)="goToInventoryPageByCreatorIdAndResourceCategory(item.categoryLinkValue, 'application')">
                        {{ getSubCategoryAmount(item.amountPerSubCategory, "application") }}
                    </div>
                    <div class="item Automation" (click)="goToInventoryPageByCreatorIdAndResourceCategory(item.categoryLinkValue, 'automation')">
                        {{ getSubCategoryAmount(item.amountPerSubCategory, "automation") }}
                    </div>
                    <div class="item Agent" (click)="goToInventoryPageByCreatorIdAndResourceCategory(item.categoryLinkValue, 'bot')">
                        {{ getSubCategoryAmount(item.amountPerSubCategory, "bot") }}
                    </div>
                    <div class="item DataStorage" (click)="goToInventoryPageByCreatorIdAndResourceCategory(item.categoryLinkValue, 'dataStorage')">
                        {{ getSubCategoryAmount(item.amountPerSubCategory, "dataStorage") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-chart>
